let channels = {};

export default class Mediator {
    constructor(name) {
        this.name = name;
        this.members = [];
    }

    add(member) {
        if (this.members.some(currentMember => currentMember === member)) return;
        this.members.push(member);
        return this;
    }

    remove(member) {
        let count = this.members.length;
        this.members = this.members.filter(currentMember => currentMember !== member);
        return this.members.length !== count;
    }

    broadcast(message, ...args) {
        let eventName = `on${message.trim()}`;
        let broadcastWasHeard = this.members.reduce((current, member) => {
            if (typeof member[eventName] !== 'undefined') {
                member[eventName](...args);
                return true;
            }

            return current;
        }, false);

        return broadcastWasHeard;
    }

    static getChannel(name) {
        if (typeof channels[name] === 'undefined') channels[name] = new Mediator(name);
        return channels[name];
    }

    static add(...props) {
        let member = props.pop(); // last argument (required)
        let channelName = props.pop() || 'default'; // first argument (optional)

        if (typeof member !== 'object') throw new Error('Cannot add non-object to Mediator');

        return Mediator.getChannel(channelName).add(member);
    }

    static remove(...props) {
        let member = props.pop(); // last argument (required)
        let channelName = props.pop() || 'default'; // first argument (optional)
        let channel = channels[channelName];
        let memberWasRemoved = false;

        if (channel) {
            memberWasRemoved = channel.remove(member);
            if (channel.members.length === 0) delete channels[channelName];
        }
        return memberWasRemoved;
    }

    static broadcast(path = '', ...props) {
        let parts = path.split(':');
        const message = parts.pop();
        const channelName = parts.pop() || 'default';
        const channel = channels[channelName];

        if (channel === undefined) return false;

        return channel.broadcast(message, ...props);
    }
}


// WEBPACK FOOTER //
// ./src/services/Mediator.js